export default {
    "app_id": 8021255,
    "group_id": 208725217,
    // "host": "https://8321-89-254-252-82.eu.ngrok.io",
    "host": "https://happy-new-year.vk-mini-app-2.ru/",
    "dev_mode": false,
};